<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <!-- 选择景点 -->
        <el-form-item label="景区">
          <el-select
            :disabled="!!form.ticketId"
            v-model="form.spotId"
            placeholder="请选择景区"
            class="fix-width"
          >
            <el-option
              v-for="item in spotList"
              :key="item.spotId"
              :label="item.title"
              :value="item.spotId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="form.typehood" size="mini">
            <el-radio-button :label="1">日票</el-radio-button>
            <el-radio-button :label="2">期票</el-radio-button>
            <el-radio-button :label="3">年卡</el-radio-button>
            <el-radio-button :label="4">项目</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- 场次列表 sectionList-->
        <el-form-item label="场次列表">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addDesc(null)"
          >
            增加
          </el-button>
          <el-table stripe :data="form.sectionList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="场次"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="80px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delDesc($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="默认价格" prop="defaultPrice">
          <el-input-number
            v-model="form.defaultPrice"
            class="fix-width"
            placeholder="请输入默认价格"
          />
          <el-button type="primary" class="ml-10" @click="specialPriceSet">
            特殊价格设置
          </el-button>
        </el-form-item>
        <el-form-item label="默认场次价格" prop="defaultSectionPrice" v-if="form.sectionList.length > 0">
          <el-row
            :gutter="10"
            v-for="(item, index) in defaultSectionPrice"
            :key="index"
          >
            <el-col :span="8">
              <el-select
                v-model="item.sectionTitle"
                placeholder="请选择场次"
              >
                <el-option
                  v-for="(sec, idx) in form.sectionList"
                  :key="idx"
                  :label="sec.title"
                  :value="sec.title"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input-number
                v-model="item.price"
                class="defult-width"
                placeholder="请输入默认价格"
              />
            </el-col>
            <el-col :span="4" v-if="form.sectionList.length > 1">
              <i class="el-icon-circle-plus-outline" @click="addPrice()"></i>
              <i
                class="el-icon-remove-outline"
                @click="minusPrice(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input
            v-model="form.unit"
            class="fix-width"
            placeholder="请输入单位"
          />
        </el-form-item>
        <el-form-item label="默认日库存" prop="defaultStock">
          <el-input-number
            v-model="form.defaultStock"
            class="fix-width"
            placeholder="请输入默认日库存"
          />
          <el-button type="primary" class="ml-10" @click="specialStockSet">
            特殊库存设置
          </el-button>
        </el-form-item>
        <!-- 标签 -->
        <el-form-item label="标签">
          <el-select
            v-model="form.tagIdList"
            multiple
            placeholder="请选择标签"
            class="fix-width"
          >
            <el-option
              v-for="item in tagList"
              :key="item.tagId"
              :label="item.title"
              :value="item.tagId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购票须知" prop="note">
          <el-input
            v-model="form.note"
            type="textarea"
            class="fix-width"
            placeholder="请输入购票须知"
          />
        </el-form-item>
        <el-form-item label="图文说明" prop="text">
          <tinymce-editor
            :height="460"
            :value="form.text"
            @inputChange="inputChange"
          ></tinymce-editor>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 特殊价格 -->
    <special-price
      ref="specialPrice"
      @special-price="specialPrice"
    ></special-price>
    <special-stock ref="specialStock"
      @special-stock="specialStock"></special-stock>
      <el-dialog
      v-model="descFormVisible"
      :close-on-click-modal="false"
      title="添加场次"
      width="600px"
      @close="descClose"
    >
      <el-form
        ref="descForm"
        label-width="120px"
        :model="descForm"
        :rules="descFormRules"
      >
        <el-form-item label="场次名称" prop="title">
          <el-input v-model="descForm.title" placeholder="请输入场次名称" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="descClose">取 消</el-button>
        <el-button type="primary" @click="descSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { create, update, findTagAll,findSpotAll } from '@/api/ticket'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
// 特殊价格
import SpecialPrice from './specialPrice.vue'
import SpecialStock  from './specialStock.vue'
export default {
  name: 'TicketEdit',
  emits: ['fetch-data'],
  components: { SpecialPrice ,SpecialStock},
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      // 提示
      mode: true,
      tagList: [],
      spotList:[],
      form: {
        ticketId: '',
        spotId:'',
        title: '',
        step:1,
        typehood: 1,
        defaultPrice: '',
        defaultStock: '',
        datePriceList: [],
        weekPriceList: [],
        dateStockList: [],
        weekStockList: [],
        unit: '',
        note: '',
        tagIdList: [],
        sectionList:[],
        text: '',
        order: 1,
      },
      defaultSectionPrice: [
        {
          sectionTitle: '',
          price: ''
        }
      ],
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        defaultPrice: [
          { required: true, trigger: 'blur', message: '请输入默认价格' },
        ],
        defaultStock: [
          { required: true, trigger: 'blur', message: '请输入默认日库存' },
        ],
      },
      dialogFormVisible: false,
      descFormVisible:false,
      descForm: {
        title:''
      },
       descFormRules: {
        title: [{ required: true, trigger: 'blur', message: '请输入场次名称' }]
      },
    }
  },
  methods: {
    // 获取特殊价格
    specialPrice(option) {
      this.form.datePriceList = option.datePriceList
      this.form.weekPriceList = option.weekPriceList
    },
    specialPriceSet() {
      this.$refs['specialPrice'].showEdit(this.form.datePriceList,this.form.weekPriceList,this.form.sectionList)
    },
    // 获取特殊kucun
    specialStock(option) {
      this.form.dateStockList = option.datePriceList
      this.form.weekStockList = option.weekPriceList
    },
    specialStockSet() {
      this.$refs['specialStock'].showEdit(this.form.dateStockList,this.form.weekStockList,this.form.sectionList)
    },
    inputChange(value) {
      this.form.text = value
    },
    // 增加场次价格
    addPrice() {
      if (this.defaultSectionPrice.length < this.form.sectionList.length) {
        this.defaultSectionPrice.push({
          sectionTitle: '',
          price: '',
        })
      }
    },
    minusPrice(index) {
      if (this.defaultSectionPrice.length > 1) {
        this.defaultSectionPrice.splice(index, 1)
      }
    },
    //获取所有景点
    async findSpotAll() {
      const res = await findSpotAll({})
      if(!res) return
      this.spotList = res
    },
    async showEdit(row) {
      this.defaultSectionPrice = [
        {
          sectionTitle: '',
          price: '',
        }
      ]
      if (row) {
        this.title = '修改门票'
        this.form.note = row.basic.note
        this.form.text = row.basic.text
        this.form.typehood = row.typehood
        this.form.order = row.basic.order
        this.form.tagIdList = row.basic.tagIdList
        this.form.ticketId = row.ticketId
        this.form.step = row.step
        this.form.sectionList = row.basic.sectionList
        this.form.spotId = row.basic.spotId
        this.form.defaultPrice = row.basic.price.defaultPrice
        this.form.datePriceList = row.basic.price.datePriceList
        this.form.weekPriceList = row.basic.price.weekPriceList
        this.form.dateStockList = row.basic.stock.dateStockList
        this.form.weekStockList = row.basic.stock.weekStockList
        this.form.defaultStock = row.basic.stock.defaultStock
        this.form.title = row.title
        if (row.basic.price && row.basic.price.defaultSectionPrice) {
          const defaultSectionPrice = []
          Object.keys(row.basic.price.defaultSectionPrice).forEach(i => {
            defaultSectionPrice.push({
              sectionTitle: i,
              price: row.basic.price.defaultSectionPrice[i]
            })
          })
          console.log('defaultSectionPrice',  defaultSectionPrice)
          this.defaultSectionPrice = defaultSectionPrice
        }
      } else {
        this.title = '新增门票'
      }
      console.log('defaultSectionPrice', this.defaultSectionPrice)
      this.getTagAll()
      this.findSpotAll()
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const ticketId = this.form.ticketId
          const defaultSectionPrice = {}
          this.defaultSectionPrice.forEach(i => {
            defaultSectionPrice[i.sectionTitle] = i.price
          })
          const data = Object.assign({}, this.form, {
            defaultSectionPrice
          })
          this.$baseConfirm(
            `你确定要${ticketId ? '修改' : '新增'}门票吗`,
            null,
            async () => {
              ticketId ? await update(data) : await create(data)
              this.$baseMessage(
                `${ticketId ? '修改' : '新增'}门票成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
    //获取标签
    async getTagAll() {
      const res = await findTagAll({ typehood: 2 })
      if (!res) return
      this.tagList = res
    },
    // 场次
    addDesc() {
      this.descFormVisible = true
    },
    delDesc(index) {
      this.form.sectionList.splice(index, 1)
    },
    descClose() {
      this.$refs['descForm'].resetFields()
      this.descForm = this.$options.data().descForm
      this.descFormVisible = false
    },
     descSave() {
      this.$refs['descForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.descForm)
          this.form.sectionList.push(form)
          this.descClose()
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.defult-width {
  width: 200px;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
}
</style>
